// 加密方法
import JSEncrypt from "jsencrypt/bin/jsencrypt.min";
import { publicKey } from "@/config/globalParam";

/**
 * 生成随机4位数字,
 */
export const randomLenNum = date => {
  let random = "";
  random = Math.ceil(Math.random() * 100000000000000)
    .toString()
    .substr(0, 4);
  if (date) random = random + Date.now();
  return random;
};

export const encryptionWord = params => {
  let { word, type, key } = params;
  // 根据环境变量控制是否执行 debugger 语句
  if (process.env.NODE_ENV === "production") {
    debugger;
  }
  console.info(publicKey);
  if (type === "Base64") {
    return btoa(word);
  } else {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(key ? key : publicKey); // 设置公钥
    return encryptor.encrypt(word); // 对需要加密的数据进行加密
  }
};
export const Decrypt = params => {};
